import { useCallback, useEffect, useState } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import { MANAGED_CONNECTION_NUDGE_DISMISSED } from "../constants";

const STORAGE_KEY = (accountId: number | undefined) =>
  `${MANAGED_CONNECTION_NUDGE_DISMISSED}-${accountId}`;

function readIsDismissed(accountId: number | undefined): boolean {
  if (globalThis.window === undefined) {
    return false;
  }
  return localStorage.getItem(STORAGE_KEY(accountId)) === "true";
}

/**
 * Per-account persisted dismissal for the managed-connection nudge card,
 * following the same localStorage pattern as useDefaultViewStorage.
 */
export function useManagedConnectionNudgeDismissed() {
  const currentAccountId = useCurrentAccountId();
  const [isDismissed, setIsDismissed] = useState(() =>
    readIsDismissed(currentAccountId),
  );

  // Re-sync when the account changes without a remount (e.g. impersonation
  // switches within the same mounted page).
  useEffect(() => {
    setIsDismissed(readIsDismissed(currentAccountId));
  }, [currentAccountId]);

  const dismiss = useCallback(() => {
    if (globalThis.window !== undefined) {
      localStorage.setItem(STORAGE_KEY(currentAccountId), "true");
    }
    setIsDismissed(true);
  }, [currentAccountId]);

  return { isDismissed, dismiss };
}
